import validateVar from "./validation/validateVariable";

function replace_all_dots(value, replace_value = ","){
    value = value + "";
    if (validateVar(value))  return value.replace(/\./g,  replace_value);
    else return value;

}

export default replace_all_dots;